import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { MuiColorInput } from 'mui-color-input';
import { TeamDetails } from '../../models/team.models';

export interface EditTeamDialogProps {
  isOpen: boolean;
  handleClose: any;
  handleSubmit: any;
  isLoading: boolean;
  teamName: string;
  teamColor: string;
  teamDescription: string;
}

export default function EditTeamDialog(props: EditTeamDialogProps) {
  const [teamForm, setTeamForm] = useState<TeamDetails>({
    name: props.teamName,
    color: props.teamColor,
    description: props.teamDescription,
  });
  const [teamNameError, setTeamNameError] = useState<string>('');
  const [teamDescriptionError, setTeamDescriptionError] = useState<string>('');

  useEffect(() => {
    setTeamForm({
      name: props.teamName,
      color: props.teamColor,
      description: props.teamDescription,
    });
  }, [props]);

  const closeModal = () => {
    props.handleClose();
  };

  const submit = () => {
    setTeamNameError('');
    setTeamDescriptionError('');
    let hasErrors = false;
    if (teamForm.name === '') {
      setTeamNameError('This field is required');
      hasErrors = true;
    }
    if (teamForm.description === '') {
      setTeamDescriptionError('This field is required');
      hasErrors = true;
    }
    if (!hasErrors) {
      props.handleSubmit(teamForm);
    }
  };

  return (
    <Dialog open={props.isOpen} onClose={closeModal}>
      <DialogTitle>Edit Team</DialogTitle>
      <DialogContent style={{ display: 'flex', minWidth: 600, flexDirection: 'column' }}>
        <TextField
          required
          label="Team Name"
          name="teamName"
          value={teamForm.name}
          variant="outlined"
          size="small"
          margin="normal"
          onChange={(evt: any) => setTeamForm({ ...teamForm, name: evt.target.value })}
          error={teamNameError.length > 1}
          helperText={teamNameError}
        />
        <MuiColorInput
          value={teamForm.color}
          onChange={(color: any) => setTeamForm({ ...teamForm, color: color })}
          size="small"
          required
          margin="normal"
        />
        <TextField
          required
          label="Description"
          name="description"
          value={teamForm.description}
          variant="outlined"
          size="small"
          margin="normal"
          onChange={(evt: any) => setTeamForm({ ...teamForm, description: evt.target.value })}
          error={teamDescriptionError.length > 1}
          helperText={teamDescriptionError}
          multiline
          rows={4}
          inputProps={{ maxLength: 200 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="error">
          Cancel
        </Button>
        <Button onClick={submit} disabled={props.isLoading}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}
